import { render, staticRenderFns } from "./RuleIntercept.vue?vue&type=template&id=31444212&scoped=true&"
import script from "./RuleIntercept.vue?vue&type=script&lang=js&"
export * from "./RuleIntercept.vue?vue&type=script&lang=js&"
import style0 from "./RuleIntercept.vue?vue&type=style&index=0&id=31444212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31444212",
  null
  
)

export default component.exports